import { ParamsTextField } from "@/modules/compute/ParamsTextField.tsx";
import { parametersByNameAtom } from "@/modules/compute/vmParametersQuery.ts";
import { useSuspenseQueryAtom } from "@/utils/query/useSuspenseQueryAtom.ts";
import { useLingui } from "@lingui/react/macro";
import { useFormContext } from "react-hook-form";

export interface VmPasswordInputs {
    password: string;
    password_confirm: string;
}

export function PasswordFields({ isNew = false, headless }: { isNew?: boolean; headless?: boolean }) {
    //#region Hooks
    const { t } = useLingui();
    const params = useSuspenseQueryAtom(parametersByNameAtom);
    //#endregion

    const passwordParams = params.get("password")!;

    const form = useFormContext<VmPasswordInputs>();

    return (
        <>
            <ParamsTextField
                form={form}
                field="password"
                params={isNew ? { ...passwordParams, mandatory: true } : passwordParams}
                type="password"
                headless={headless}
                autoComplete="new-password"
                label={isNew ? t`New password` : t`Password`}
                // XXX: Overrides the description from the params
                description={t`Password for the user. Must contain at least one lowercase and one uppercase ASCII letter (a-z, A-Z) and at least one digit (0-9). Minimum length is 8 characters.`}
            />

            <ParamsTextField
                form={form}
                field="password_confirm"
                params={isNew ? { ...passwordParams, mandatory: true } : passwordParams}
                type="password"
                headless={headless}
                autoComplete="new-password"
                label={t`Confirm password`}
                registerOptions={{
                    deps: ["password"],
                    validate: (value, { password }) => {
                        return value === password || t`Passwords do not match`;
                    },
                }}
                description={t`The re-typed password, to ensure that it has been entered correctly.`}
            />
        </>
    );
}
